import {gql} from '@apollo/client'

export const START_IMPORT = gql`
  mutation StartImport($input: StartImportInput!) {
    startImport(input: $input) {
      id
      provider
      active
      files {
        uploadId
        filename
        filesize
        status
        failure
        uploadStatus
      }
      skipped {
        fileId
        filename
        reason
      }
    }
  }
`
